import { render, staticRenderFns } from "./MMP_OrganizationsModal.vue?vue&type=template&id=54bd7149&scoped=true&"
import script from "./MMP_OrganizationsModal.vue?vue&type=script&lang=js&"
export * from "./MMP_OrganizationsModal.vue?vue&type=script&lang=js&"
import style0 from "./MMP_OrganizationsModal.vue?vue&type=style&index=0&id=54bd7149&prod&scoped=true&lang=css&"
import style1 from "./MMP_OrganizationsModal.vue?vue&type=style&index=1&id=54bd7149&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd7149",
  null
  
)

export default component.exports